import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Lägg till en interceptor för att sätta Authorization header
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Befintlig error interceptor
api.interceptors.response.use(
  response => response,
  error => {
    // Logga endast i utvecklingsmiljö
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', error);
    }
    return Promise.reject(error);
  }
);

export const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) return null;
  if (avatarPath.startsWith('http')) return avatarPath;
  return `${API_URL}${avatarPath}`;
};

/**
 * Authorization-header för rå fetch.
 *
 * Axios-instansen ovan har en interceptor som sätter headern, men stora delar av
 * appen anropar med `fetch` och går då förbi den. Flera endpoints låg öppna just
 * därför: de kunde inte kräva inloggning utan att anropen slutade fungera.
 *
 * Använd som `fetch(url, { headers: authHeaders() })`, eller sprid in den i ett
 * befintligt headerobjekt: `{ ...authHeaders(), 'Content-Type': 'application/json' }`.
 */
export const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export { API_URL, SOCKET_URL };

// Exportera även en funktion för att kontrollera miljön
export const isDevelopment = () => process.env.NODE_ENV === 'development';